/* eslint-disable react/prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unescaped-entities */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useDebounce } from 'react-use';
import PropTypes from 'prop-types';
import CornerSpinner from 'components/CornerSpinner';
import { useQueryClient } from '@tanstack/react-query';
import {
  FolderIcon,
  CrossIcon,
  Edit,
  Delete,
  MoveIcon2,
  GreaterArrow,
  ArrowBackIcon,
  ArrowForwardIcon,
  AddIcon,
  DuplicateIcon,
  Icon,
} from 'utils/icons';
import { useHomeScreenContext } from 'layouts/HomeScreenLayout/contexts/HomeScreenContext';
import MoveBudgets from '../../components/MoveBudgets';
import { toast } from 'react-toastify';
import Chip from 'components/Chip';
import { useGroupMutation } from 'utils/api/mutations';
import {
  useTable,
  useSortBy,
  useRowSelect,
  useGlobalFilter,
} from 'react-table';
import { useTabsQueries, useGroupFringeQuery } from 'utils/api/queries';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.scss';
import EditGroup from 'components/EditGroup';
import DeleteFolder from 'components/DeleteFolder';
import CreateGroups from 'components/CreateGroups';
import DeleteMultiFringe from 'components/DeleteFringe';
import { formatCurrency } from 'utils/helper';
import SearchInput from 'components/SearchInput';
import { useLocation } from 'react-router-dom';

const GroupFringes = props => {
  // Contexts and Hooks
  const {
    createTabsMutation,
    showCreateGroupsModal,
    setshowCreateGroupsModal,
    activeBudget,
    hasEditAccess,
  } = useHomeScreenContext();
  const queryClient = useQueryClient();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const instanceType = queryParams.get('type') || 'budget';

  // suggestion bar
  const [scrollPosition, setScrollPosition] = useState(0);
  const contextualSuggestionsRef = useRef();

  // State Variables

  const [searchTxt, setSearchTxt] = useState('');
  const [showMovePopup, setShowMovePopup] = useState(false);
  const [shouldCallApi, setShouldCallApi] = useState(true);
  const [groupName, setgroupName] = useState('');
  const [groupId, setgroupId] = useState('');
  const [groupFriges, setGroupFriges] = useState([]);

  const [, setparentId] = useState(null);
  const [parentNames, setparentNames] = useState([]);
  const [products, setProducts] = useState([]);
  const [showEditBudgetFolder, setShowEditBudgetFolder] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const productsRef = useRef(products);
  const [allTotal, setAllTotal] = useState(0);
  const [filteredGroups, setFilteredGroups] = useState([]);

  const { data: default_Groups, refetch: refetchGroups } =
    useGroupFringeQuery.useGroupFringeDetailsQuery({
      filters: {
        instance_type: 'user',
        active_id: activeBudget,
      },
      enabled: shouldCallApi,
    });

  useEffect(() => {
    if (default_Groups?.data?.data) {
      setFilteredGroups(default_Groups.data.data);
    }
  }, [default_Groups]);

  const {
    data: group_details,
    isLoading,
    refetch,
  } = useGroupFringeQuery.useGroupFringeDetailsQuery({
    enabled: true,
    filters: {
      ...(searchTxt ? { search: searchTxt } : {}),
      instance_type: props.instanceType,
      active_id: activeBudget,
    },
  });

  const groupData = group_details?.data;

  // Tabs Data Fetching
  const { data: tabsDetails } = useTabsQueries.useOpenTabsQuery({
    enabled: true,
  });
  const tabsData = tabsDetails?.data;

  // Modify useEffect to filter out suggestions when the listing group names change
  useEffect(() => {
    if (!isLoading && groupData?.data && default_Groups?.data?.data) {
      const listingGroupNames = new Set(
        groupData.data.map(group => group.name)
      );

      const newProducts = groupData.data.map(group => ({
        id: group.id,
        full_name: group.name,
        group_total: group.group_total,
        fringes: group.fringe.map(item => item.display_name).join(', '),
        fringeIds: group.fringe.map(item => item.id).join(','),
      }));

      setProducts(prevProducts => {
        // Map old products to be updated
        const updatedProducts = prevProducts.map(oldItem => {
          const updated = newProducts.find(item => item.id === oldItem.id);
          return updated || oldItem;
        });

        // Add new items that aren't already in the list
        newProducts.forEach(item => {
          if (!updatedProducts.some(existing => existing.id === item.id)) {
            updatedProducts.push(item);
          }
        });

        // Optional: Sort alphabetically or by group_total if you want consistent sorting
        return updatedProducts.filter(up =>
          newProducts.some(np => np.id === up.id)
        );
      });

      const filteredSuggestions = default_Groups.data.data.filter(
        defaultGroup => !listingGroupNames.has(defaultGroup.name)
      );
      setFilteredGroups(filteredSuggestions);

      setLoading(false);
    }
  }, [isLoading, groupData, default_Groups, activeBudget, searchTxt]);

  // Context Functions from HomeScreenContext
  const {
    setSelectDelGroup,
    selectedBudget,
    showDeleteFolder,
    makeAciveTabMutation,
    selectTab,
    setOpenTabsList,
    showDeleteFringe,
  } = useHomeScreenContext();

  // Effect to Keep Products Ref Updated
  useEffect(() => {
    // Update the ref value whenever the products state changes
    productsRef.current = products;
  }, [products]);

  // Effect to Reset Selected Rows When Data Changes
  useEffect(() => {
    setSelectedRows([]);
  }, [products]);

  const handleApiSearch = () => {
    setShouldCallApi(true);
    refetch();
  };

  useDebounce(
    () => {
      handleApiSearch();
    },
    500,
    [searchTxt]
  );

  const { mutateAsync: duplicateGroup } =
    useGroupMutation.useDuplicateGroupMutation();

  const handleCreateTabs = useCallback(
    async selRowsData => {
      const payload = selRowsData.map(row => ({
        budget: row.id,
      }));

      try {
        const response = await createTabsMutation.mutateAsync(payload);
        const newTabs = response?.data;
        await makeAciveTabMutation.mutateAsync(newTabs[0]?.id);
        setOpenTabsList([...(tabsData || []), ...(newTabs || [])]);

        window.location.href = '/home';
      } catch (error) {
        console.error('Error creating fringe-group tab:', error);
        toast.error('Failed to create tabs');
      }
    },
    [createTabsMutation, makeAciveTabMutation, setOpenTabsList, tabsData]
  );

  // Columns Definition for React Table

  const columns = useMemo(
    () => [
      {
        Header: (
          <>
            <span
              className="header-txt"
              style={{ marginRight: '5px', marginLeft: '50px' }}
            >
              Group(s)
            </span>
            {/* <Search /> */}
          </>
        ),
        accessor: 'full_name',
        sticky: 'left',
        Cell: ({ row }) => (
          <div
            className={
              row?.original?.type === 'Folder'
                ? 'uname-cell-fringe-group cursorpointer'
                : 'uname-cell-fringe-group cursorpointer'
            }
          >
            <input
              type="checkbox"
              checked={selectedRows.some(
                selectedRow => selectedRow.id === row.original.id
              )}
              style={{
                cursor: 'pointer',
                width: '16px',
                height: '16px',
                margin: '0px 10px 0px 5px',
              }}
              onChange={event => {
                handleSelectRow(event, row);
              }}
              className="custom-checkbox"
            />
            <img
              // src={BudgetIcon}
              alt=""
              onClick={event => {
                selectTab(row?.original?.id, row?.original);
                handleCreateTabs([row?.original]);
              }}
            />
            &nbsp;
            <span
              style={{ marginRight: '10px' }}
              onClick={() => {
                if (row?.original?.type === 'Folder') {
                  // setparentNames(prevParents => [
                  //   ...prevParents,
                  //   {
                  //     name: row?.original?.full_name,
                  //     parent_id: row?.original?.id,
                  //     id: row?.original?.parent_id,
                  //   },
                  // ]);
                  setparentNames(prevParents => {
                    // Check if the id already exists in the array
                    const idExists = prevParents.some(
                      parent => parent.id === row?.original?.parent_id
                    );

                    if (!idExists) {
                      // If the id doesn't exist, append the new object
                      return [
                        ...prevParents,
                        {
                          name: row?.original?.full_name,
                          parent_id: row?.original?.id,
                          id: row?.original?.parent_id,
                        },
                      ];
                    } else {
                      // If the id already exists, you can choose to update the existing object or ignore the new one
                      // For example, you might want to update the name property of the existing object:
                      return prevParents.map(parent => {
                        if (parent.id === row?.original?.parent_id) {
                          return {
                            ...parent,
                            name: row?.original?.full_name,
                          };
                        }
                        return parent;
                      });
                      // Alternatively, you can just return the existing state without any changes
                      // return prevParents;
                    }
                  });

                  setparentId(row?.original?.id);
                } else {
                  setgroupName(row?.original?.full_name);
                  setgroupId(row?.original?.id);
                  setGroupFriges(row?.original?.fringeIds);

                  setShowEditBudgetFolder(true);
                }
              }}
            >
              {row.original.full_name}{' '}
            </span>
          </div>
        ),
        sortType: 'caseInsensitiveSort',
        disableSortBy: false,
      },
      {
        Header: 'Fringes',
        accessor: 'fringes',
        sticky: 'left',
        disableSortBy: true,
      },
      {
        Header: 'Group Total',
        accessor: 'group_total',
        sticky: 'left',
        disableSortBy: false,
        Cell: ({ value }) => <div>{formatCurrency(value)}</div>,
      },
      {
        Header: 'Actions',
        accessor: 'actions',
        sticky: 'left',
        disableSortBy: true,
        Cell: ({ row }) => (
          <div className="folder-actions-wrapper cursorpointer">
            <>
              {row?.original?.type === 'Folder' ? (
                <>
                  <MoveIcon2
                    title="Move"
                    className="move-icon"
                    onClick={() => {
                      setSelectedRows([row?.original]);
                      setShowMovePopup(true);
                    }}
                  />
                </>
              ) : (
                <>
                  <Edit
                    onClick={() => {
                      setgroupName(row?.original?.full_name);
                      setgroupId(row?.original?.id);
                      setGroupFriges(row?.original?.fringeIds);
                      setShowEditBudgetFolder(true);
                    }}
                  />
                  <DuplicateIcon
                    title="Duplicate"
                    className="cursorpointer"
                    style={{ marginRight: '10px' }}
                    onClick={async () => {
                      try {
                        await duplicateGroup(row?.original?.id);
                        toast.success('Group duplicated successfully');
                        refetch();
                        refetchGroups();
                      } catch (error) {
                        console.error('Error duplicating fringe group:', error);
                        toast.error('Failed to duplicate group');
                      }
                    }}
                  />
                  <Delete
                    title="Delete"
                    onClick={() => {
                      setSelectDelGroup([row?.original]);
                    }}
                  />
                </>
              )}
            </>
          </div>
        ),
      },
    ],
    [
      duplicateGroup,
      handleCreateTabs,
      refetch,
      refetchGroups,
      selectTab,
      selectedRows,
      setSelectDelGroup,
    ]
  );

  // React Table Instance
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data: products,
        sortTypes: {
          caseInsensitiveSort: (rowA, rowB, columnId) => {
            const a = rowA.values[columnId]?.toString().toLowerCase();
            const b = rowB.values[columnId]?.toString().toLowerCase();

            if (a > b) return 1;
            if (a < b) return -1;
            return 0;
          },
        },
        initialState: { pageIndex: 0 },
        disableSortRemove: true,
      },
      useGlobalFilter,
      useSortBy,
      useRowSelect
    );

  // Handle Checkbox Selection
  const handleSelectRow = (event, row) => {
    const isChecked = event?.target?.checked;
    if (isChecked) {
      setSelectedRows(prevSelected => {
        const updatedSelected = [...prevSelected, row.original];
        setAllTotal(
          (updatedSelected || []).reduce((acc, curr) => {
            return acc + (curr.group_total || 0);
          }, 0)
        );
        return updatedSelected;
      });
    } else {
      setSelectedRows(prevSelected =>
        prevSelected.filter(selectedRow => selectedRow.id !== row.original.id)
      );
    }
  };

  // Handle Modal Closure
  const closeFolder = () => {
    setshowCreateGroupsModal(false);
    setShowMovePopup(false);
    setShowEditBudgetFolder(false);
    setLoading(false);
    refetchGroups();
    refetch();
  };

  // Handle Move Popup Closure
  const handleMovePopupClose = () => {
    setShowMovePopup(false);
    setSelectedRows([]);
    setparentNames([]);
    setparentId(null);
    refetch(); // Refetch fringes data after moving
  };

  // Handle Search Input Change
  const handleSearchChange = event => {
    const value = event?.target?.value;
    setSearchTxt(value);

    if (value === '') {
      // setSearchTxt('');
      setShouldCallApi(true);
      refetch();
    }
  };

  // Handle Clearing Search
  // const handleClearSearch = () => {
  //   setSearchTxt('');
  //   setSearchQuery('');
  // };

  // Handle Create Fringe Modal
  const handleCreateFringe = () => {
    setshowCreateGroupsModal(true);
  };

  // const filteredFringes = useMemo(() => {
  //   if (!defaultFringe || !fringes) return [];

  //   // Get all abbreviations used in budget fringes
  //   const budgetAbbreviations = new Set(
  //     fringes.map(fringe => fringe.abbreviation)
  //   );

  //   // Show defaults that DON'T have matching abbreviations in budget fringes
  //   return defaultFringe.filter(
  //     defaultItem => !budgetAbbreviations.has(defaultItem.abbreviation)
  //   );
  // }, [fringes, defaultFringe]);

  // Custom Sort Function for Case-Insensitive Sorting

  const { mutate: creategroup } = useGroupMutation.useCreateGroupMutation({
    onMutate: async newGroup => {
      await queryClient.cancelQueries(['GroupDetails']);
      const previousFringes = queryClient.getQueryData(['GroupDetails']);
      queryClient.setQueryData(['GroupDetails'], old => ({
        ...old,
        data: [...old.data, newGroup],
      }));
      return { previousFringes };
    },
    onError: (err, newGroup, context) => {
      queryClient.setQueryData(['GroupDetails'], context.previousFringes);
      console.error('Error creating fringe group from suggestion:', err);
    },
    onSettled: () => {
      queryClient.invalidateQueries(['GroupDetails']);
    },
  });
  // Handle Add Suggestion
  const handleAddSuggestion = suggestion => {
    const newGroup = {
      name: suggestion.name,
      instance_type: props.instanceType,
      budget: activeBudget,
      fringe: suggestion.fringe,
    };

    creategroup(newGroup, {
      onSuccess: () => {
        refetch();
        setFilteredGroups(prevGroups =>
          prevGroups.filter(group => group.name !== suggestion.name)
        );
      },
    });
  };

  const renderContextualSuggestions = () => (
    <div className="contextual-suggestions">
      <div className="contextual-suggestions__title">Suggestions:</div>
      <div className="contextual-suggestions__container">
        <ArrowBackIcon
          className={`back-icon ${scrollPosition > 0 ? '' : 'disabled'}`}
          onClick={() => {
            if (scrollPosition > 0) {
              setScrollPosition(Math.max(scrollPosition - 350, 0));
            }
          }}
        />
        <div
          className="contextual-suggestions__container__chip-wrapper"
          ref={contextualSuggestionsRef}
        >
          {filteredGroups.map(item => (
            <Chip
              key={item.id}
              className="suggestions-chip"
              title={item.name}
              icon={<AddIcon />}
              onClick={() => handleAddSuggestion(item)}
              disabled={instanceType === 'budget' && !hasEditAccess()}
            />
          ))}
        </div>
        <ArrowForwardIcon
          className={`forward-icon ${
            scrollPosition <
            (contextualSuggestionsRef.current?.scrollWidth || 0)
              ? ''
              : 'disabled'
          }`}
          onClick={() => {
            const scrollWidth =
              contextualSuggestionsRef.current?.scrollWidth || 0;
            if (scrollPosition < scrollWidth) {
              setScrollPosition(Math.min(scrollPosition + 350, scrollWidth));
            }
          }}
        />
      </div>
    </div>
  );

  return (
    <>
      <div className="budget-details-wrapper mt-3">
        {/* Header Section */}
        <div className="details-header-wrapper">
          <div className="details-left d-flex align-items-center">
            <div className="detail-header">
              {instanceType === 'user'
                ? 'User Groups'
                : `${selectedBudget?.name} Groups`}
            </div>
            <div className="fringe-toggle-container">{props.toggleButtons}</div>
          </div>
          <div className="d-flex gap-3">
            {loading && (
              <>
                {/* <CircularProgress size={30} thickness={2} color={'info'} /> */}
              </>
            )}
            <SearchInput
              onChange={handleSearchChange}
              onFocus={handleSearchChange}
              //  handleClearSearch={handleClearSearch}
              searchVal={searchTxt}
              placeholder="Filter Groups..."
            />
          </div>
          <div className="details-right d-flex align-items-center">
            <button
              label="Add New Fringe"
              type="button"
              className="btn btn-primary new-folder"
              onClick={handleCreateFringe}
              disabled={instanceType === 'budget' && !hasEditAccess()}
            >
              {/* <NewBudget /> */}
              Add New Fringe Group
            </button>
          </div>
        </div>
        {/* Loading Indicator */}
        {loading ? (
          <CornerSpinner isLoading size="sm" label="Loading fringes" />
        ) : (
          <>
            {/* Breadcrumb Navigation */}
            {parentNames?.length > 0 && (
              <div className="folders-path">
                <div
                  className="bud-hed cursorpointer"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  My Budgets
                </div>
                <GreaterArrow />
                {parentNames?.map((item, index) => (
                  <div className="folder-data" key={item}>
                    <FolderIcon />
                    <div
                      className="bud-head cursorpointer"
                      onClick={() => {
                        if (item?.parent_id === null) {
                          window?.location?.reload();
                        } else {
                          setparentId(item?.parent_id);
                          const indexOfParent15 = parentNames.findIndex(
                            parentData =>
                              parentData?.parent_id === item?.parent_id
                          );
                          const newArray =
                            indexOfParent15 !== -1
                              ? parentNames.slice(0, indexOfParent15 + 1)
                              : parentNames;
                          setparentNames(newArray);
                          setShouldCallApi(true);
                        }
                      }}
                    >
                      {item?.name}
                    </div>
                    {index < parentNames.length - 1 && <GreaterArrow />}
                  </div>
                ))}
              </div>
            )}

            {/* Selected Rows Actions */}
            {selectedRows?.length > 1 && (
              <div className="selected-records-wrapper">
                <div className="sel-rec-item-count">
                  <CrossIcon onClick={() => setSelectedRows([])} />
                  {selectedRows?.length}{' '}
                  {selectedRows?.length === 1 ? 'item' : 'items'} selected
                </div>
                <div
                  style={{
                    marginRight: 'auto',
                    marginLeft: '20px',
                    color: 'black',
                    fontWeight: '1000',
                    fontSize: '1.2em', // Increase size for a bolder look
                  }}
                >
                  Total Amount of Selected Fringes: {formatCurrency(allTotal)}
                </div>
                <div className="actions-wrapper">
                  <Delete
                    title="Delete"
                    onClick={() => setSelectDelGroup(selectedRows)}
                  />
                </div>
              </div>
            )}

            {/* Table Section */}
            <div className="admin-users-body">
              <div
                className={
                  selectedRows?.length > 0
                    ? 'table-container-fringe-groups table-new-height mt-3'
                    : 'table-container-fringe-groups mt-3'
                }
              >
                <table {...getTableProps()} className="table-cls w-100">
                  {/* Table Header */}
                  <thead className="app-users-table-head-group">
                    {headerGroups?.map(headerGroup => (
                      <tr
                        {...headerGroup.getHeaderGroupProps()}
                        key={headerGroup.id}
                      >
                        {headerGroup.headers?.map(column => (
                          <th
                            {...column.getHeaderProps(
                              column.getSortByToggleProps()
                            )}
                            key={column.id}
                          >
                            {column.render('Header')}
                            <span>
                              &nbsp;
                              {!column.disableSortBy &&
                                (column.isSorted ? (
                                  <span className="sorted-icon-highlight">
                                    {column.isSortedDesc ? (
                                      // Descending: Z-A for text, 9-1 for numbers
                                      column.id === 'group_total' ||
                                      column.id === 'value' ? (
                                        <Icon
                                          name="ArrowUp91Icon"
                                          style={{
                                            width: '12px',
                                            height: '12px',
                                          }}
                                        />
                                      ) : (
                                        <Icon
                                          name="ArrowUpZAIcon"
                                          style={{
                                            width: '12px',
                                            height: '12px',
                                          }}
                                        />
                                      )
                                    ) : // Ascending: A-Z for text, 1-9 for numbers
                                    column.id === 'group_total' ||
                                      column.id === 'value' ? (
                                      <Icon
                                        name="ArrowDown19Icon"
                                        style={{
                                          width: '12px',
                                          height: '12px',
                                        }}
                                      />
                                    ) : (
                                      <Icon
                                        name="ArrowDownAZIcon"
                                        style={{
                                          width: '12px',
                                          height: '12px',
                                        }}
                                      />
                                    )}
                                  </span>
                                ) : (
                                  <Icon
                                    name="SortIcon"
                                    style={{ width: '12px', height: '12px' }}
                                  />
                                ))}
                            </span>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>

                  {/* Table Body */}
                  {rows && products?.length > 0 ? (
                    <tbody
                      {...getTableBodyProps()}
                      className="table-scroll-group"
                    >
                      {rows.map(row => {
                        prepareRow(row);
                        const isSelected = selectedRows.some(
                          selectedRow => selectedRow.id === row.original.id
                        );
                        return (
                          <tr
                            {...row.getRowProps()}
                            className={`table-body-row-group ${
                              isSelected ? 'selected-row' : ''
                            }`}
                            key={row.id}
                          >
                            {row.cells.map((cell, cellIndex) => (
                              <td
                                {...cell.getCellProps()}
                                key={cellIndex}
                                style={{
                                  width: cellIndex === 0 ? '40%' : 'auto',
                                  paddingLeft:
                                    cellIndex === 0 ? '50px' : 'auto',
                                }}
                              >
                                {cell.render('Cell')}
                              </td>
                            ))}
                          </tr>
                        );
                      })}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan={columns.length}>
                          <div className="no-budget-found">
                            {searchTxt ? (
                              <>
                                <div className="no-found-head">
                                  No Groups Found
                                </div>
                                <div className="no-found-body">
                                  No groups match your search: "{searchTxt}"
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="no-found-head">
                                  Create a Group
                                </div>
                                <div className="no-found-body">
                                  {instanceType === 'user'
                                    ? 'User does not have any groups.'
                                    : 'You do not have any groups at the moment.'}
                                </div>
                                <button
                                  label="New Budget"
                                  type="button"
                                  className="btn btn-primary new-folder"
                                  onClick={() => setshowCreateGroupsModal(true)}
                                  disabled={
                                    instanceType === 'budget' &&
                                    !hasEditAccess()
                                  }
                                >
                                  Add New Fringe Group
                                </button>
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </>
        )}
      </div>
      <div
        style={{
          position: 'absolute',
          bottom: '35px',
          width: '100%',
        }}
      >
        {instanceType !== 'user' && renderContextualSuggestions()}
      </div>
      {/* Conditional Rendering of Modals */}
      {showDeleteFringe && <DeleteMultiFringe refetch={refetch} />}
      {showDeleteFolder && <DeleteFolder refetch={refetch} />}
      {showMovePopup && (
        <MoveBudgets
          showMovePopup={showMovePopup}
          onMoveClose={handleMovePopupClose}
          selBudgets={selectedRows}
          refetch={refetch}
        />
      )}
      {showCreateGroupsModal && (
        <CreateGroups
          closeFolder={closeFolder}
          showCreateGroupsModal={showCreateGroupsModal}
          refetch={refetch}
        />
      )}
      {showEditBudgetFolder && (
        <EditGroup
          GroupId={groupId}
          GroupFringes={groupFriges}
          GroupName={groupName}
          showCreateGroupsModal={showEditBudgetFolder}
          closeFolder={closeFolder}
          refetch={refetch}
        />
      )}
    </>
  );
};

// PropTypes Validation
GroupFringes.propTypes = {
  budgetList: PropTypes.array,
  instanceType: PropTypes.string,
  row: PropTypes.shape({
    original: PropTypes.shape({
      type: PropTypes.string,
      id: PropTypes.number,
      full_name: PropTypes.string,
      // ... add other properties as needed
    }),
  }),

  // New prop for ToggleButtons
  toggleButtons: PropTypes.node,
};

export default GroupFringes;
